<template>
    <div
        class="cubeSpace d-flex flex-wrap justify-content-center align-items-center py-5 px-lg-3 px-4 px-lg-0 my-3 my-lg-0">
        <div
            class="col-12 col-lg-5 d-flex flex-wrap justify-content-center align-items-center align-content-center overflow-hidden">
            <div
                class="col-lg-7 col-xl-6 col-12 d-flex justify-content-lg-end justify-content-center text-center align-items-center flex-wrap px-lg-0 px-3 my-3 my-lg-0">
                <img :src="a58" class="img-fluid w-75 imagen-movil">
            </div>
        </div>
        <div
            class="col-12 col-lg-7 d-flex flex-wrap justify-content-center align-items-center align-content-center overflow-hidden">
            <!-- <div class="col-12 d-flex justify-content-start sin-imagen">
                <div class="col-xl-11 col-6 d-flex justify-content-end mb-3"><img :src="a38"
                        class="img-fluid stringImg"></div>
            </div> -->
            <div class="col-12 d-flex justify-content-center text-start align-items-center flex-wrap px-lg-4">
                <span class="font- fuente-posm label-1 d-flex flex-wrap fuentes-clamp">Cada ticket se convierte en<br>
                    <span>feedback Instantáneo</span>
                    <span class="font- label-2  fuente-nova mt-3 ps-3 w-100 fuentes-clamp2">Nuestro QR dinámico se
                        imprime automáticamente en cada ticket de venta, revolucionando la forma de obtener feedback.
                        Cada encuesta ya conoce toda la experiencia: qué productos se ordenaron, el horario de visita y
                        el mesero que brindó el servicio.

                        <br><br>
                        Elimina preguntas innecesarias y obtén insights precisos que conectan directamente la
                        experiencia del cliente con tus datos operativos en tiempo real.
                    </span>
                </span>
            </div>
            <div class="col-12 d-flex justify-content-start">
                <span class="col-xl-11 d-flex justify-content-end mt-5">
                    <button class="button-outline hover-boton_mod font- fuente-nova2" @click="showModal">
                        Descubre Como
                    </button>
                </span>
            </div>
        </div>
    </div>
</template>

<script>
import { openContactModal } from '@/utils/modalHelper'

export default {
    name: 'page1',
    emits: ['sendAction'],
    props: {
        action: {
            type: Object,
            default: () => { }
        }
    },
    watch: {
        action: {
            handler() {
                this.getAction()
            },
            deep: true
        }
    },
    data() {
        return {
            a58: require('@/assets/images/a58.webp'),
            a38: require('@/assets/images/a38.webp')
        }
    },
    methods: {
        makeAction() {
            switch (this.action.type) {
                case '?':
                    break
            }
        },
        showModal() {
            openContactModal();
        }
    },
}
</script>

<style lang="css" scoped>
.cubeSpace {
    overflow: hidden;
    height: auto;
    width: 100vw;
    height: 100vh;
}

.label-1 {
    color: var(--color-2);
    font-size: 70px;
    line-height: 1.1;
    max-width: 950px;
    word-wrap: break-word;
}

.label-2 {
    color: var(--color-3);
    font-size: 29px;
    line-height: 1.1;
}

.stringImg {
    max-width: 300px;
}

@media (max-width: 992px) and (min-width: 768px) {
    .label-1 {
        font-size: 60px;
    }

    .label-2 {
        font-size: 27px;
    }
}

@media (max-width: 767px) and (min-width: 0) {
    .label-1 {
        font-size: 28px;
    }

    .label-2 {
        font-size: 19px;
    }
}
</style>
